exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".policies[data-v-039c5556]{text-align:left}.pc-head[data-v-039c5556]{margin-bottom:16px}.pc-title[data-v-039c5556]{font-size:16px;font-weight:600}.pc-sub[data-v-039c5556]{margin-left:12px;color:#888;font-size:13px}.pc-file[data-v-039c5556],.pc-path[data-v-039c5556]{font-family:Menlo,Consolas,monospace;font-size:12px;background:#f5f5f5;padding:2px 6px;border-radius:3px;color:#333;word-break:break-all}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-039c5556","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/admin/views/Policies.vue
// module id = 140
// module chunks = 0